import { FC } from 'react'

import styled from 'styled-components'

import { InboxDocument } from 'src/Redux/api/documentsApi'
import { Loader } from 'src/Components/Loader'
import { colors } from 'src/Helpers/constants'

import { InboxDocumentCard } from './InboxDocumentCard'
import { InboxDocumentsHeader } from './InboxDocumentsHeader'

const Container = styled.div`
  width: 100%;
  overflow-y: auto;
  flex: 1;
`

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 60px 20px;
`

const EmptyText = styled.span`
  font-size: 20px;
  color: ${colors.thirdGray};
  opacity: 0.6;
`

const DocumentsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

interface InboxDocumentsListProps {
  documents?: InboxDocument[]
  isLoading: boolean
  onApprove: (documentId: string) => void
  onReject: (documentId: string) => void
  onViewHistory: (documentId: string) => void
}

export const InboxDocumentsList: FC<InboxDocumentsListProps> = ({
  documents,
  isLoading,
  onApprove,
  onReject,
  onViewHistory,
}) => {
  if (isLoading) {
    return (
      <LoaderWrapper>
        <Loader size='lg' />
      </LoaderWrapper>
    )
  }

  if (!documents || documents.length === 0) {
    return (
      <EmptyState>
        <EmptyText>Нет документов для согласования</EmptyText>
      </EmptyState>
    )
  }

  return (
    <Container>
      <InboxDocumentsHeader />
      <DocumentsStack>
        {documents.map((doc) => (
          <InboxDocumentCard
            key={doc.id}
            document={doc}
            onApprove={onApprove}
            onReject={onReject}
            onViewHistory={onViewHistory}
          />
        ))}
      </DocumentsStack>
    </Container>
  )
}
